<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="mp-question">
        <span class="mp-bar mp-bar--xl"></span>
      </div>
      <div class="mp-board">
        <div class="mp-col">
          <div
            v-for="i in 4"
            :key="'l' + i"
            class="mp-card mp-card--left"
            :data-row="i - 1"
          >
            <span class="mp-bar mp-bar--md"></span>
          </div>
        </div>
        <svg class="mp-lines" viewBox="0 0 100 100" preserveAspectRatio="none">
          <line
            x1="0"
            y1="12"
            x2="100"
            y2="38"
            class="mp-line"
            style="--line-i: 0"
          />
          <line
            x1="0"
            y1="38"
            x2="100"
            y2="88"
            class="mp-line"
            style="--line-i: 1"
          />
          <line
            x1="0"
            y1="62"
            x2="100"
            y2="12"
            class="mp-line"
            style="--line-i: 2"
          />
          <line
            x1="0"
            y1="88"
            x2="100"
            y2="62"
            class="mp-line"
            style="--line-i: 3"
          />
        </svg>
        <div class="mp-col">
          <div
            v-for="i in 4"
            :key="'r' + i"
            class="mp-card mp-card--right"
            :data-row="i - 1"
          >
            <span class="mp-bar mp-bar--md"></span>
          </div>
        </div>
      </div>
    </template>

    <template #audience>
      <span class="mp-phone-q"></span>
      <div class="mp-phone-board">
        <div class="mp-phone-col">
          <span v-for="i in 3" :key="'pl' + i" class="mp-phone-card mp-phone-card--left">
            <span class="mp-bar mp-bar--md"></span>
          </span>
        </div>
        <div class="mp-phone-col">
          <span v-for="i in 3" :key="'pr' + i" class="mp-phone-card mp-phone-card--right">
            <span class="mp-bar mp-bar--md"></span>
          </span>
        </div>
        <svg class="mp-phone-line-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
          <line
            x1="0"
            y1="20"
            x2="100"
            y2="50"
            class="mp-phone-line"
          />
        </svg>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewMatchPairs',
  components: { PreviewFrame },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
})
</script>

<style scoped lang="scss">
.mp-bar {
  display: block; height: 6px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.18);
}
.mp-bar--xl { width: 70%; height: 8px; }
.mp-bar--md { width: 60%; }

.mp-question {
  padding-bottom: 6px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}

.mp-board {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 60px 1fr;
  gap: 8px;
  align-items: center;
  flex: 1;
}
.mp-col {
  display: grid; gap: 6px;
}
.mp-card {
  background: white;
  border: 1px solid rgba(15, 15, 20, 0.12);
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
}
.mp-card--right { justify-content: flex-end; }
.mp-card--right .mp-bar { background: color-mix(in srgb, var(--accent) 25%, rgba(15,15,20,0.1)); }

.mp-lines {
  position: absolute;
  top: 0; left: calc((100% - 60px) / 2 + 2px);
  width: 56px; height: 100%;
  pointer-events: none;
  overflow: visible;
}
.mp-line {
  stroke: var(--accent);
  stroke-width: 2;
  stroke-linecap: round;
  fill: none;
  stroke-dasharray: 110;
  stroke-dashoffset: 110;
  animation: mp-draw 4s ease-out infinite;
  animation-delay: calc(var(--line-i, 0) * 220ms + 400ms);
}

/* ---- Audience phone ---- */
.mp-phone-q {
  display: block; height: 8px; border-radius: 999px;
  width: 70%; background: rgba(15, 15, 20, 0.18);
  margin-bottom: 4px;
}
.mp-phone-board {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  flex: 1;
}
.mp-phone-col { display: grid; gap: 5px; }
.mp-phone-card {
  background: color-mix(in srgb, var(--accent) 6%, white);
  border: 1px solid rgba(15, 15, 20, 0.08);
  border-radius: 6px;
  padding: 6px;
  display: flex;
}
.mp-phone-card--right { justify-content: flex-end; }
.mp-phone-line-svg {
  position: absolute; inset: 0;
  width: 100%; height: 100%;
  pointer-events: none;
}
.mp-phone-line {
  stroke: var(--accent);
  stroke-width: 2.5;
  stroke-linecap: round;
  fill: none;
  stroke-dasharray: 130;
  stroke-dashoffset: 130;
  animation: mp-draw 4s ease-out infinite;
  animation-delay: 800ms;
}

@keyframes mp-draw {
  0%, 8%   { stroke-dashoffset: 130; }
  50%      { stroke-dashoffset: 0; }
  92%, 100% { stroke-dashoffset: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .mp-line, .mp-phone-line { animation: none; stroke-dashoffset: 0; }
}
</style>
